module.exports = __webpack_public_path__ + "img/a997635481a7b9afa0fe348f79d7bcff.svg";